import { useStyle } from '@/classify';
import { useWindowSize } from '@/common/hooks/useWindowSize';
import { GET_CART_DETAILS_QUERY } from '@/hooks/SignIn/signIn.gql';
import { useSignIn } from '@/hooks/SignIn/useSignIn';
import { cn } from '@/lib/utils';
import { isRequired } from '@/util/formValidators';
import { Form } from 'informed';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from '../Button';
import ErrorMessage from '../ErrorMessage';
import Field from '../Field';
import GoogleRecaptcha from '../GoogleReCaptcha';
import LinkButton from '../LinkButton';
import Password from '../Password';
import TextInput from '../TextInput';
import defaultClasses from './signIn.module.css';

const SignIn = props => {
  const classes = useStyle(defaultClasses, props.classes);
  const {
    setDefaultUsername = () => {},
    showCreateAccount = () => {},
    showForgotPassword = () => {},
    afterSubmit,
    showTitle = true,
    showFooter = true,
    initialValues,
    showImage = false,
    className,
  } = props;

  const { formatMessage } = useIntl();

  const [hasSignInError, setHasSignInError] = useState(false);

  const talonProps = useSignIn({
    getCartDetailsQuery: GET_CART_DETAILS_QUERY,
    setDefaultUsername,
    showCreateAccount,
    afterSubmit,
    showForgotPassword,
  });

  const windowSize = useWindowSize();

  const isMobile = windowSize.innerWidth <= 640;

  const {
    formApiRef,
    errors,
    handleCreateAccount,
    handleForgotPassword,
    handleSubmit,
    isBusy,
    loading,

    recaptchaWidgetProps,
  } = talonProps;

  const forgotPasswordClasses = {
    root: classes.forgotPasswordButton,
  };

  const maybeHeader = showTitle ? (
    <h1 className='mb-[20px] text-left font-teko-medium text-[28px] uppercase leading-[28px] text-primary lg_mb-[60px] lg_text-[40px] lg_leading-[48px]'>
      Sign In
    </h1>
  ) : null;

  const maybeMobileForgotPasswordButton = isMobile ? (
    <div className={classes.mobileForgotPasswordButtonContainer}>
      <LinkButton
        classes='font-roboto-regular font-normal underline text-[12px] leading-[24px] '
        type='button'
        onClick={handleForgotPassword}
      >
        <FormattedMessage
          id={'signIn.forgotPasswordText'}
          defaultMessage={'Forgot Your Password?'}
        />
      </LinkButton>
    </div>
  ) : null;

  useEffect(() => {
    if (errors && errors.get('signInMutation')) {
      setHasSignInError(true);
    } else {
      setHasSignInError(false);
    }
  }, [errors]);

  return (
    <div className={cn('w-full', className)}>
      {/* {!isMobile && showImage && (
        <Image
          src={signinImage}
          alt='Sign In'
          className='h-[700px] w-[700px]'
        />
      )} */}
      <div className=''>
        <div className='px-[12px] lg_px-0'>
          {hasSignInError && <ErrorMessage>{'Incorrect Email/Password, please try again.'}</ErrorMessage>}
          {maybeHeader}
          <Form
            className=''
            onSubmit={handleSubmit}
            initialValues={initialValues && initialValues}
            formApiRef={formApiRef}
          >
            <div className='mb-[10px] w-full lg_w-[530px]'>
              <Field
                id='email'
                label={formatMessage({
                  id: 'signIn.emailText',
                  defaultMessage: 'Email',
                })}
                classes={{
                  requiredLabel: classes.requiredLabel,
                }}
                required
              >
                <TextInput
                  id='email'
                  autoComplete='email'
                  field='email'
                  placeholder='Email'
                  validate={isRequired}
                />
              </Field>
            </div>
            <div className='relative mb-[20px] w-full lg_w-[530px]'>
              <Password
                fieldName='password'
                id='Password'
                label={formatMessage({
                  id: 'signIn.passwordText',
                  defaultMessage: 'Password*',
                })}
                placeholder='Password'
                validate={isRequired}
                autoComplete='current-password'
                isToggleButtonHidden={false}
                required
                classes={{
                  label: classes.labelClasses,
                  requiredLabel: classes.requiredLabel,
                }}
              />
              <LinkButton
                classes={{
                  root: 'cursor-pointer inline-flex items-center justify-center pointer-events-auto text-center absolute right-0 top-[10px] font-roboto-regular leading-[24px]  underline text-[#4C4C4C] text-[12px]',
                }}
                type='button'
                onClick={handleForgotPassword}
              >
                <FormattedMessage
                  id={'signIn.forgotPasswordText'}
                  defaultMessage={'Forgot Your Password?'}
                />
              </LinkButton>
            </div>

            <GoogleRecaptcha {...recaptchaWidgetProps} />
            {/* {maybeMobileForgotPasswordButton} */}
            <Button
              priority='high'
              className='duration-300 mb-[10px] h-[40px] w-full rounded-full bg-black font-roboto-medium font-medium text-white transition-all hover_bg-[#4c4c4c] lg_h-[50px] lg_w-[140px]'
              type='submit'
              disabled={isBusy}
              loading={loading}
            >
              <FormattedMessage
                id={'signIn.signInText'}
                defaultMessage={'Sign In'}
              />
            </Button>
            <p className='text-center lg_text-left'>
              <span className='font-roboto-light text-[16px] font-light leading-[26px]'>Not a member? </span>
              <LinkButton
                classes={{
                  root: 'cursor-pointer inline-flex items-center justify-center pointer-events-auto text-center font-roboto-medium font-medium leading-[26px]  underline text-[#0A0A0A] text-[16px]',
                }}
                type='button'
                onClick={handleCreateAccount}
              >
                <FormattedMessage
                  id={'signIn.joinNowText'}
                  defaultMessage={'Register Now'}
                />
              </LinkButton>
            </p>

            {/* {maybeFooter} */}
          </Form>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
